import React,{useState,useEffect} from 'react';
import "./SpaRequest.css";
import PrevIcon from "../../../assets/icons/PrevIcon.svg";
import CloseIcon from "../../../assets/icons/closeIcon.svg";
import SearchIcon from "../../../assets/icons/Search.svg";
import { useNavigate,useLocation } from 'react-router-dom';
import useAuth from '../../../customHooks/useAuth';
import SpaCard from './SpaCard/SpaCard';
import Photo from "../../../assets/photo.png";

export default function SpaRequest() {

  const navigate = useNavigate();
  const location = useLocation();

  // Refresh Handle
  useAuth();

  
  const bookedRooms = location.state?.bookedRooms || [];
  const menu = location.state?.spaServices || [];
  const spaCartItems = location.state?.spaCart || [];   


  const bookingId = location.state?.bookingId || "";
  const hotelId = location.state?.hotelId || "";
  const hotelAddress = location.state?.hotelAddress || "";
  const hotelName = location.state?.hotelName || '';
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const status = location.state?.status || "";
  const activeTab = location.state?.activeTab || "";

  // console.log("Hotel Id : ",hotelId);
  
  const [isSearching, setIsSearching] = useState(false); // State to toggle between h2 and input



  // UseState
  // For Spa Cart
 
  const [spaCart,setSpaCart] = useState([]);
 
  useEffect(()=>{
    if(spaCartItems.length > 0) {
      setSpaCart(spaCartItems);
    }
  },[spaCartItems]); // set Spa Cart items from Location
  
  // For Total Price
  const [totalPrice,setTotalPrice] = useState(0);
  
  // This is for Search
  const [inputs,setInputs] = useState({
    search : ""
  });

  // Filter the menu based on the search query
  const filteredMenu = menu.filter((spa) =>
    spa.name.toLowerCase().includes(inputs.search.toLowerCase())
  );
  // console.log("Spa Cart : ",spaCart);


  // For Total Price
  useEffect(() => {
    const totalPrice = ()=>{
      let price = 0;
      spaCart.map((food)=>(
        price +=food.price*food.quantity
      ));
      return price;
    };
    let price = totalPrice();
    setTotalPrice(price);
  },[spaCart])


  // Confirm The Order
  const handleConfirm = ()=> {
    navigate("/spaSummary",{state : {
      menu : menu,
      spaCart : spaCart,
      totalPrice : totalPrice,
      bookedRooms : bookedRooms,
      bookingId : bookingId,
      hotelId : hotelId,
      hotelAddress : hotelAddress,
      hotelName : hotelName,
      checkInDate : checkInDate,
      checkOutDate : checkOutDate,
      status  : status,
      activeTab : activeTab,
    }});
  }


  // Move Back
  const moveBack = ()=>{
    navigate(`/bookings/${bookingId}`);
  }

  // Handle Change
  const handleChange = (e) => {
    const {name,value} = e.target;
    setInputs({...inputs,[name]:value});
  }


  // For Searching
  const handleSearchClick = () => {
    setIsSearching(true); // Switch to search input field
  };

  // For Close Searching
  const handleCloseSearch = () => {
    setInputs({
      search : ""
    });

    setIsSearching(false); // Close search field and show h2 again
  };


  // console.log("Filtered Menu : ",filteredMenu);

  return (
  <div className="spaRequest">
    {/* Header */}
    <div className="spaRequest-header">
      <div className="spaRequest-icons">
        <img src={PrevIcon} onClick={moveBack}  alt="error" />
        
        {isSearching ? 
          (
            <>
            <input
              type="text"
              placeholder="Search..."
              className='searchField'
              autoFocus // Focuses on the input when it appears
              name="search"
              value={inputs.search || ""}
              onChange={handleChange}
            />
            <img
              src={CloseIcon} // Close icon source
              alt="CloseIcon"
              width = "32px"
              height="32px"
              onClick={handleCloseSearch}
              style={{ cursor: "pointer" }} // Optional: Add a pointer cursor for better UX
            />
          </>

          ) :
          (
            <>
            <h2>Spa Menu</h2>
              <img
                src={SearchIcon} // Search icon
                alt="SearchIcon"
                onClick={handleSearchClick}
                style={{ cursor: "pointer" }} // Optional: Add a pointer cursor for better UX
              />
            </>
          )
        }
        
   
      
      
      </div>
    </div>

    {/* Spa Services Data  */}
    <div className="spa-menu">
    {
      filteredMenu.length > 0 ? (
        filteredMenu.map((spa, index) => (
          (spa.photos && spa.photos.length>0) ? (
            <>
              {/* {console.log("Spa Phott : " + spa.photos[0])} */}
              <SpaCard
                key={index}
                name={spa.name}
                price={spa.price}
                desc={spa.description}
                photo={spa.photos[0]}
                errorPhoto = {Photo}
                id={spa.id}
                spaCart={spaCart}
                setSpaCart={setSpaCart}
              />
            </>
          ) :  (
            <>
              {/* {console.log("Spa Phott : " + spa.photos[0])} */}
              <SpaCard
                key={index}
                name={spa.name}
                price={spa.price}
                desc={spa.description}
                photo={Photo}
                
                id={spa.id}
                spaCart={spaCart}
                setSpaCart={setSpaCart}
              />
            </>
          )
        ))
      ) : (
        menu.map((spa, index) => (
          
          (spa.photos && spa.photos.length>0) ? (
            <>
            {/* {console.log("Spa Phott : " + spa.photos[0])} */}
            <SpaCard
              key={index}
              name={spa.name}
              price={spa.price}
              desc={spa.description}
              photo={spa.photos[0] ? spa.photos[0] : Photo}
              errorPhoto = {Photo}
              id={spa.id}
              spaCart={spaCart}
              setSpaCart={setSpaCart}
            />
            </>
          ) :(
            <>
            {/* {console.log("Spa Phott : " + spa.photos[0])} */}
            <SpaCard
              key={index}
              name={spa.name}
              price={spa.price}
              desc={spa.description}
              photo={Photo}
              id={spa.id}
              spaCart={spaCart}
              setSpaCart={setSpaCart}
            />
            </>
          )
        ))
      )
    }

    </div>


    {/* Spa Confirmation */}
    <div className="spa-confirmation">
      <div className="spa-price-data">
        <h4>{totalPrice} ₹ <span>{spaCart.length} Items</span></h4>
      </div>
      <div className="spa-price-btn">
        <button onClick={handleConfirm}  disabled={spaCart.length===0}>Confirm Order</button>
      </div>
    </div>
  </div>
  )
}
